<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" routerLink="/administration/diagnoses/add">
        {{ 'authenticated.administration.diagnoses.create_btn' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<app-table id="dashboard.administration.diagnoses.index"></app-table>
